/* eslint-disable */
export const initGallery = () => {
	const galleryThumbs = $('.gallery-thumbs');
	const galleryTop = $('.gallery-top');

	/* slick */
	galleryThumbs && galleryThumbs.slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.gallery-top',
		dots: false,
		arrows: false,
		prevArrow: '<button type="button" class="slick-prev mx-auto block"><svg class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.9997 10.8284L7.04996 15.7782L5.63574 14.364L11.9997 8L18.3637 14.364L16.9495 15.7782L11.9997 10.8284Z" fill="rgba(245,207,111,1)"></path></svg></button>',
		nextArrow: '<button type="button" class="slick-next mx-auto block"><svg class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.0003 13.1716L16.95 8.22183L18.3643 9.63605L12.0003 16L5.63629 9.63605L7.05051 8.22183L12.0003 13.1716Z" fill="rgba(245,207,111,1)"></path></svg></button>',
		mobileFirst: true,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					vertical: true,
					arrows: true,
				}
			},
		],
	});

	galleryTop && galleryTop.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: galleryThumbs ? '.gallery-thumbs' : null,
	});
}

export const sliderBundlesRelated = () => {
	const sliderBundle = $('.related-bundles .slider');

	sliderBundle && sliderBundle.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		mobileFirst: true,
		dots: true,
		adaptiveHeight: true,
		autoplay: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					autoplay: false,
					adaptiveHeight: false,
					dots: false,
					arrows: true,
					prevArrow: `<button type="button" class="slick-prev mx-auto flex w-16 h-16 items-center justify-center absolute left-3 top-1/2 z-10 transform translate-y-full transition rounded-full hover:bg-primary pr-2">
					<svg xmlns="http://www.w3.org/2000/svg" width="18.438" height="34.048" viewBox="0 0 18.438 34.048">
						<path id="Vector_9" data-name="Vector 9" d="M16.317,32.634,0,16.317,16.317,0" transform="translate(1.414 0.707)" fill="none" stroke="#d8a64b" stroke-width="2"/>
					</svg>
					</button>`,
					nextArrow: `<button type="button" class="slick-next mx-auto flex w-16 h-16 items-center justify-center absolute right-3 top-1/2 z-10 transform translate-y-full transition rounded-full hover:bg-primary pl-2">
					<svg xmlns="http://www.w3.org/2000/svg" width="18.438" height="34.048" viewBox="0 0 18.438 34.048">
						<path id="Vector_9" data-name="Vector 9" d="M0,32.634,16.317,16.317,0,0" transform="translate(0.707 0.707)" fill="none" stroke="#d8a64b" stroke-width="2"/>
					</svg>
					</button>`,
				}
			}
		]
	});
}

export const sliderSingleBlog = () => {
	const sliderBlog = $('.slider-blog .slider');
	
	sliderBlog && sliderBlog.slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		autoPlay: true,
		responsive: [
			{
				breakpoint: 851,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: false
				}
			},
			{
				breakpoint: 651,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}